import React, { Fragment, useRef, useState, useEffect } from 'react';
import imgHeadphone from '../../assets/images/instantsupport-headphones.png';
import Topbar from './Topbar';
import { Helmet } from 'react-helmet';
import {
  errorToast,
  successToast,
  getPathForInstantSupport,
  informativeToast
} from '../../utils/helper';
import { StatCard, STAT_ICONS } from '../../component/common/designSystem';
import InstantSupportTable from './InstantSupportTable';
import Pagination from '../../component/common/Pagination/Pagination';
import { Dialog, Transition } from '@headlessui/react';
import Table from '../../component/common/Table';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CompanyApi } from '../../api/companyApi';
import SearchInput from '../../component/common/Input/SearchInput';
import dummyAvatar from '../../assets/images/dummy-avatar.png';
import CommonPopover from '../../component/common/popover';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import instantSupportTick from '../../assets/images/instant-support-tickmark.svg';
import { set } from 'date-fns';
import instantSupportDialogIcon from '../../assets/images/instantSupportDialogIcon.svg';
import LandingPage from './LandingPage';
import Loader from '../../component/common/Loader';
import Insights from './Insights';
import { Search } from 'lucide-react'; // Icon for search
import UpgradeDownArrow from '../../assets/images/upgrade-down-arrow.svg';
import InfoPopup from '../../component/common/InfoPopup';

const InstantSupportIndexPage = () => {
  const { userType, companyId } = JSON.parse(localStorage.getItem('userData'));
  const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedPerPage, setSelectedPerPage] = useState({ name: '10', value: 10 });
  const [addUsersOpen, setaddUsersOpen] = useState(false);
  const [updateUsersPlanOpen, setupdateUsersPlanOpen] = useState(false);
  const [upgradeUserPaymentDialogOpen, setupgradeUserPaymentDialogOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const cancelButtonRef = useRef(null);
  const [theAddUsersList, settheAddUsersList] = useState([]);
  const [numberOfUsersForUpgradeUsers, setnumberOfUsersForUpgradeUsers] = useState(10);
  const [deactivateInstantSupportOpen, setdeactivateInstantSupportOpen] = useState(false);
  const [noticeToSwitchToCustomSupportOpen, setnoticeToSwitchToCustomSupportOpen] = useState(false);

  const [allocatedNumberForTheCompany, setallocatedNumberForTheCompany] = useState(0);
  const [supportStatusforTheCompany, setsupportStatusforTheCompany] = useState();
  const [planPurchaseDate, setplanPurchaseDate] = useState('');

  const [selectedPlan, setSelectedPlan] = useState(''); // 1 selectedPlan
  const [openPlan, setOpenPlan] = useState(''); // 2 same as selectedPlan
  const [employeeCount, setEmployeeCount] = useState(0); // 3 numberOfEmployees
  const [isAnnual, setIsAnnual] = useState(true); // 4 billingType
  const [typeOfPayment, settypeOfPayment] = useState();
  // insights useState
  const [companyTotaltSeatsInsights, setcompanyTotaltSeatsInsights] = useState(0);
  const [companyUsedSeatsInights, setcompanyUsedSeatsInights] = useState(0);

  const [companyHasInstantSupoortPlan, setcompanyHasInstantSupoortPlan] = useState(false);

  const [loader, setLoader] = useState(true);
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  //

  // const planNametoPrice = {
  //   telephonic: 15, // Telephonic EAP
  //   face: 24, // Face to Face & Video Services EAP
  //   rise: 48 // Shoorah RISE Plan
  // };

  const planNamesToPlanIDs = {
    telephonic: 'plan456',
    face: 'plan457',
    rise: 'plan458'
  };

  const planIDs = {
    0: 'telephonic', // Telephonic EAP
    1: 'face', // Face to Face & Video Services EAP
    2: 'rise' // Shoorah RISE Plan
  };

  const plans = {
    telephonic: {
      title: 'Telephonic EAP',
      price: 1.1,
      priceAnnually: 14.5,
      planRequirements: [
        '24/7, 365 telephone counselling and advice line',
        'Up to 6 structured counselling sessions per issue per year',
        'In-the-moment support between counselling sessions',
        'Personal financial/debt support through Auriga',
        'Legal advice through Irwin Mitchell',
        'Critical incident advice and telephone support',
        'Support for those with care responsibilities'
      ]
    },
    face: {
      title: 'Face to Face & Video Services EAP', // Face to Face & Video Services EAP
      price: 1.35,
      priceAnnually: 23.0,
      planRequirements: [
        'Includes all Telephonic EAP benefits',
        'Access to telephone, virtual, or face-to-face counselling',
        '10% discount on our B2B Premium plan'
      ]
    },
    rise: {
      title: 'Shoorah RISE Plan', // Shoorah RISE Plan
      price: 2.75,
      priceAnnually: 46.0,
      planRequirements: [
        'Includes all Face-to-Face & Video Services EAP benefits',
        'Enhanced psychological assessments, complex case support, CBT, and EMDR therapy',
        'Access to enhanced psychological assessments, complex case support and complex case management when deemed clinically appropriate. This includes CBT and EMDR therapy.',
        'Full case management for maximised clinical outcomes',
        '24/7, 365 health and wellbeing advice',
        'Online GP consultation services',
        'Full Premium access to our App and B2B suite'
      ]
    }
  };

  //

  const [selectedUsers, setSelectedUsers] = useState([]);

  const toggleUser = (index, id) => {
    setSelectedUsers((prevSelectedUsers) => {
      const exists = prevSelectedUsers.some((user) => user.userId === id);

      if (exists) {
        return prevSelectedUsers.filter((user) => user.userId !== id); // Remove if exists
      } else {
        return [...prevSelectedUsers, { userId: id }]; // Add if not exists
      }
    });
    console.log('Selected Users', selectedUsers);
  };

  useEffect(() => {
    CompanyApi.getInstantSupportAddUsersList(companyId).then((response) => {
      if (response?.data) {
        settheAddUsersList(response?.data?.data);
      } else if (response?.code === 401) {
        errorToast('Something went wrong, please try again later !');
      }
    });
  }, [addUsersOpen, companyId]);

  useEffect(() => {
    // loading start

    //console.log('loading start', loader);
    setLoader(true);
    CompanyApi.getInstantSupportCompanyStatus(companyId)
      .then((response) => {
        if (response?.status === 200) {
          const {
            billingType,
            numberOfEmployees,
            selectedPlan,
            allocatedNumber,
            type,
            supportStatus,
            purchaseDate
          } = response?.data;

          console.log('response of company status ', response?.data);

          // Update all the states at once
          setallocatedNumberForTheCompany(allocatedNumber);
          setsupportStatusforTheCompany(supportStatus);
          setEmployeeCount(numberOfEmployees);
          setSelectedPlan(planIDs[selectedPlan]);
          setOpenPlan(planIDs[selectedPlan]);
          setIsAnnual(billingType === 'yearly' ? true : false);
          settypeOfPayment(type);
          setplanPurchaseDate(purchaseDate);

          setcompanyHasInstantSupoortPlan(true);
        }
      })
      .catch((error) => {
        console.error('Error fetching company status at index page:', error);
        setcompanyHasInstantSupoortPlan(false);
      })
      .finally(() => {
        // loading stop
        setLoader(false);
      });
    // /company/v1/instantSupport/insights?companyID=678f327a6e509d84980488c9
    CompanyApi.getInstantSupportInights(companyId).then((response) => {
      if (response?.status === 200) {
        console.log('these are the insights :', response?.data?.data);
        setcompanyTotaltSeatsInsights(response?.data?.data?.totalSeats);
        setcompanyUsedSeatsInights(response?.data?.data?.activeUsersCount);
      }
    });
  }, [companyId]);

  let isAdmin;
  isAdmin =
    userType === 0 || userType === 1 ? true : userType === 3 || userType === 4 ? false : true;

  const subAdminStatusCards = [
    <StatCard
      icon={STAT_ICONS.seats}
      title={'Total seats'}
      value={companyTotaltSeatsInsights}
    />,
    <StatCard
      icon={STAT_ICONS.activeUsers}
      title={'Used Seats'}
      value={companyUsedSeatsInights}
    />,
    <StatCard
      icon={STAT_ICONS.newUsers}
      title={'Available Seats'}
      value={companyTotaltSeatsInsights - companyUsedSeatsInights}
    />
  ];

  const handleAddUsers = () => {
    console.log('here is the selected users', selectedUsers);
    const payloadForAddingUsers = {
      companyId: companyId,
      selectedUsers: selectedUsers
    };

    try {
      CompanyApi.postInstantSupportAddUsers(payloadForAddingUsers).then((response) => {
        if (response?.status === 200) {
          console.log('This is the response for postInstantSupportAddUsers', response);
        }
      });
    } catch (error) {
      console.log('This error is by fail to call AddUsers API', error);
    } finally {
      setSelectedUsers([]);
    }

    setaddUsersOpen(false);
  };

  const handleUpgradeUsers = () => {
    setLoader(true);
    const payloadForUpgradeUsers = {
      type: typeOfPayment,
      companyID: companyId,
      numberOfEmployees: parseInt(numberOfUsersForUpgradeUsers),
      upgradeType: 1
    };

    console.log('THIS IS THE PAYLOAD FOR upgrade users :', payloadForUpgradeUsers);

    CompanyApi.postUpdateUserAndInstantsupportPlan(payloadForUpgradeUsers)
      .then((response) => {
        if (response?.status === 200) {
          // const paymentLink = response?.data?.data?.paymentLink;
          // console.log('postInstantSupportUpgradeUsers paymentLink:', paymentLink);

          // if (paymentLink) {
          //   window.open(paymentLink, '_blank'); // Opens the payment link in a new tab
          // }
          if (response?.data?.meta?.code === 1) {
            console.log('Message from Upgrade Users API :', response?.data?.meta?.message);
            setLoader(false);
            successToast(response?.data?.meta?.message);
          }
          setupdateUsersPlanOpen(false);
          setupgradeUserPaymentDialogOpen(true);
        } else if (response?.status === 404) {
          setLoader(false);
          errorToast('Failed to upgrade users');
        }
      })
      .catch((error) => {
        console.log('This error is by fail to call postInstantSupportUpgradeUsers', error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const deactivateInstantSupport = () => {
    const payLoadForDeactivateInstantSupport = {
      companyId: companyId,
      userId: '',
      status: 'InActive',
      toggle: true
    };
    CompanyApi.postInstnatSupportUserStatus(payLoadForDeactivateInstantSupport)
      .then(async (response) => {
        if (response?.status === 200) {
          console.log(
            'response from active-deactivate FOR TURNING OFF INSTANT SUPPORT API ',
            response
          );
        } else if (response?.status === 400) {
          console.log('Returning status 400 ERROR AT deactivateInstantSupport');
        }
      })
      .catch((error) => {
        console.log('Error At deactivateInstantSupport :', error);
      })
      .finally(() => {
        setdeactivateInstantSupportOpen(false);
      });
  };

  const filteredUsers = theAddUsersList.filter((member) =>
    member.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const [componentKey, setComponentKey] = useState(0); // Key to force re-render

  const handleRefreshOfTable = async () => {
    //if (selectedUsers.length === 0) return;

    setLoader(true); // Show loader

    await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulate an API call

    setComponentKey((prevKey) => prevKey + 1); // Change the key to force re-mount
    setLoader(false); // Hide loader
  };

  const [needsRefresh, setNeedsRefresh] = useState(false);

  // Function to trigger refresh across components

  useEffect(() => {
    console.log('Updated needsRefresh in parent:', needsRefresh);
  }, [needsRefresh]);

  const triggerRefresh = () => {
    setLoader(false);
    setNeedsRefresh(true);
  };

  // Function to acknowledge that refresh has completed
  const refreshCompleted = () => {
    setNeedsRefresh(false);
    setLoader(false);
  };
  const fetchInfo = async () => {
    if (userType === 4 || userType === 3) {
      try {
        const response = await CompanyApi.getInfoData('eap_b2b');
        if (response?.data?.meta?.code === 200) {
          if (response?.data?.data?.tutorialsData?.length > 0) {
            setOpen(true);
            setInfo(response?.data?.data);
          } else {
            setOpen(false);
            errorToast('Tutorial not found');
          }
        } else {
          setInfo(null);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          {companyHasInstantSupoortPlan ? (
            <>
              <div className="relative lg:mb-[45px]">
                <Helmet>
                  <meta charSet="utf-8" />
                  <title>B2B | Instant Support</title>
                </Helmet>
                <div className="mt-2 sm:mt-3"></div>
                <Topbar
                  title="Instant Support (EAP)"
                  infoBtn={true}
                  setOpen={setOpen}
                  fetchInfo={fetchInfo}
                />
                {loader && <Loader />}
              </div>

              <div className="relative lg:mb-[45px]">
                {/* <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 h-auto gap-4 mt-5">
                  {subAdminStatusCards.map((item, index) => (
                    <React.Fragment key={index}>{item}</React.Fragment>
                  ))}
                </div> */}
                <Insights
                  key={needsRefresh}
                  needsRefresh={needsRefresh}
                  refreshCompleted={refreshCompleted}
                />

                <div className="xl:px-8 lg:px-6 px-4 py-[10px] sm:mt-6 mt-4  bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border border-gray-200 rounded-lg flex sm:justify-between justify-center mb-0 items-center">
                  <div className="hidden font-medium text-sm sm:flex">
                    <span>
                      Assigned Number {'  '} - {'  '}
                      <span className="text-[1.2rem] font-bold">
                        {supportStatusforTheCompany === 1
                          ? 'In Progress'
                          : supportStatusforTheCompany === 4
                          ? 'Disabled'
                          : allocatedNumberForTheCompany}
                      </span>
                    </span>
                  </div>

                  <div className="flex flex-row sm:flex-nowrap items-center gap-2">
                    <button
                      className="btn-primary btn-sm h-[32px] border-[1.5px]"
                      onClick={() => {
                        if (supportStatusforTheCompany === 1)
                          return informativeToast(
                            'Your Instant Support plan is under review, you can add users once it is approved by Shoorah'
                          );
                        if (supportStatusforTheCompany === 4)
                          return informativeToast(
                            'Your Instant Support plan is disabled, please contact Shoorah'
                          );
                        setaddUsersOpen(true);
                      }}
                    >
                      Add Users
                    </button>
                    <CommonPopover
                      label={
                        <>
                          <span className="flex items-center space-x-2">
                            Upgrade
                            <img className="ml-2" src={UpgradeDownArrow} alt="edit" />
                          </span>
                        </>
                      }
                      className="btn-primary btn-sm h-[32px] border-[1.5px]"
                      contentClassName="w-52 mt-1 p-2 flex flex-col items-center"
                    >
                      <ul className="text-base w-36 pt-2 pb-2 space-y-1 border-t mt-1">
                        <li>
                          <button
                            className="text-base"
                            onClick={() =>
                              typeOfPayment === 1
                                ? navigate(getPathForInstantSupport('/instant-support/get-support'))
                                : navigate(
                                    getPathForInstantSupport('/instant-support/upgrade-plans')
                                  )
                            }
                          >
                            {typeOfPayment === 1 ? 'Purchase' : 'Upgrade'} Plan
                          </button>
                        </li>
                      </ul>
                      {typeOfPayment !== 1 && (
                        <ul className="text-base w-36 pt-2 pb-2 space-y-1 border-t mt-1">
                          <li>
                            <button
                              className="text-base"
                              onClick={() => {
                                if (supportStatusforTheCompany === 4)
                                  return informativeToast(
                                    'Your Instant Support plan is disabled, please contact Shoorah'
                                  );
                                setupdateUsersPlanOpen(true);
                              }}
                            >
                              Upgrade Users
                            </button>
                          </li>
                        </ul>
                      )}
                    </CommonPopover>

                    {typeOfPayment !== 1 ? (
                      <>
                        <CommonPopover
                          label={
                            <>
                              {selectedTheme ? (
                                <>
                                  <svg
                                    className=""
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                      stroke="white"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                                      stroke="white"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                                      stroke="white"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </>
                              ) : (
                                <>
                                  <svg
                                    className=""
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                      stroke="black"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                                      stroke="black"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                                      stroke="black"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </>
                              )}
                            </>
                          }
                          className="h-[32px] text-xs px-4 py-1.5 border-none  font-medium flex items-center"
                          contentClassName="w-52 mt-1 p-2 flex flex-col items-center "
                        >
                          <ul className="text-base font-medium w-36 pt-2 pb-2 space-y-1">
                            <li>
                              <button
                                className="text-base font-medium"
                                onClick={() => {
                                  setnoticeToSwitchToCustomSupportOpen(true);
                                }}
                              >
                                Custom Number
                              </button>
                            </li>
                          </ul>
                          {supportStatusforTheCompany != 4 && (
                            <ul className="text-base text-[#F93D40] font-medium w-36 pt-2 pb-2 space-y-1 border-t mt-1">
                              <li>
                                <button
                                  className="text-base"
                                  onClick={() => {
                                    setdeactivateInstantSupportOpen(true);
                                  }}
                                >
                                  Deactivate Feature
                                </button>
                              </li>
                            </ul>
                          )}
                        </CommonPopover>
                      </>
                    ) : (
                      <>
                        <CommonPopover
                          label={
                            <>
                              <svg
                                className=""
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                                  stroke="black"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </>
                          }
                          className="h-[32px] text-xs px-4 py-1.5 border-none  font-medium flex items-center"
                          contentClassName="w-52 mt-1 p-2 flex flex-col items-center "
                        >
                          <ul className="text-base font-medium w-36 pt-2 pb-2 space-y-1">
                            <li>
                              <button
                                className="text-base font-medium"
                                onClick={() => {
                                  navigate(
                                    getPathForInstantSupport('/instant-support/add-custom-number')
                                  );
                                }}
                              >
                                Edit Number
                              </button>
                            </li>
                          </ul>
                          <ul className="text-base text-[#F93D40] font-medium w-36 pt-2 pb-2 space-y-1 border-t mt-1">
                            <li>
                              <button
                                className="text-base "
                                onClick={() => setdeactivateInstantSupportOpen(true)}
                              >
                                Deactivate Feature
                              </button>
                            </li>
                          </ul>
                        </CommonPopover>
                      </>
                    )}
                  </div>
                </div>

                <InstantSupportTable
                  data={[]}
                  key={componentKey}
                  triggerRefresh={triggerRefresh}
                  setLoader={setLoader}
                />
              </div>

              <InfoPopup
                open={open}
                data={info}
                title="Instant Support"
                handleClose={() => setOpen(false)}
              />
            </>
          ) : (
            <>
              <LandingPage />
            </>
          )}
        </>
      )}

      {/* UI ends here  */}

      {/* Dialoge Box for Add Users  */}
      <Transition.Root appear show={addUsersOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          initialFocus={cancelButtonRef}
          onClose={setaddUsersOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 dark:bg-black bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-white dark:bg-gray-800 text-left transition-all sm:my-8 sm:w-full sm:max-w-[692px]">
                  <div className="bg-white dark:bg-gray-800 p-6 border border-gray-300 dark:border-shoorah-darkBorder rounded-lg">
                    <div className="flex justify-between items-center mb-4">
                      <p className="text-xl font-normal">Add On</p>
                      <button
                        className="text-gray-500 hover:text-gray-700"
                        onClick={() => {
                          setaddUsersOpen(false);
                          setSelectedUsers([]);
                        }}
                      >
                        {' '}
                        {selectedTheme ? (
                          <>
                            <svg
                              width="46"
                              height="46"
                              viewBox="0 0 46 46"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.2499 28.7495L28.7499 17.2495"
                                stroke="#F3F4F6"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M28.7499 28.7505L17.2499 17.2505"
                                stroke="#F3F4F6"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </>
                        ) : (
                          <>
                            <svg
                              width="46"
                              height="46"
                              viewBox="0 0 46 46"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.2499 28.7495L28.7499 17.2495"
                                stroke="#1E2A3B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M28.7499 28.7505L17.2499 17.2505"
                                stroke="#1E2A3B"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </>
                        )}
                      </button>
                    </div>

                    <div className="flex items-center w-full">
                      {/* Search Box */}
                      <div className="relative w-[518px]">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                        <input
                          type="text"
                          placeholder="Search"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          className="pl-10 w-full h-10 rounded-full bg-[#EEEEEE] text-[12px] text-gray-600 placeholder-gray-400 border-none outline-none focus:ring-2 focus:ring-gray-300"
                        />
                      </div>

                      {/* Done Button */}
                      <button
                        type="button"
                        className={`ml-4 px-6 py-2 text-sm font-medium text-white rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                          selectedUsers.length > 0
                            ? 'bg-[#1F1F1F] hover:bg-[#1F1F1F] focus:ring-[#1F1F1F]'
                            : 'bg-gray-400 cursor-not-allowed'
                        }`}
                        onClick={() => {
                          if (selectedUsers.length > 0) handleAddUsers();
                          handleRefreshOfTable();
                        }}
                        disabled={selectedUsers.length === 0}
                      >
                        Done
                      </button>
                    </div>

                    <style jsx global>{`
                      /* Ultra-thin scrollbar styles */
                      .ultra-thin-scrollbar::-webkit-scrollbar {
                        width: 2px !important; /* Extra thin scrollbar */
                        height: 2px !important;
                      }

                      .ultra-thin-scrollbar::-webkit-scrollbar-track {
                        background: transparent !important;
                        margin: 0 !important;
                        border: none !important;
                      }

                      .ultra-thin-scrollbar::-webkit-scrollbar-thumb {
                        background: rgba(180, 180, 180, 0.5) !important;
                        border-radius: 2px !important;
                        border: none !important;
                      }

                      .ultra-thin-scrollbar::-webkit-scrollbar-thumb:hover {
                        background: rgba(150, 150, 150, 0.7) !important;
                      }

                      /* Completely hide scrollbar buttons */
                      .ultra-thin-scrollbar::-webkit-scrollbar-button {
                        display: none !important;
                        width: 0 !important;
                        height: 0 !important;
                        background: transparent !important;
                        border: none !important;
                      }

                      /* Firefox scrollbar */
                      .ultra-thin-scrollbar {
                        scrollbar-width: thin !important;
                        scrollbar-color: rgba(180, 180, 180, 0.5) transparent !important;
                      }

                      /* Hide up/down buttons in Firefox */
                      .ultra-thin-scrollbar * {
                        scrollbar-width: thin !important;
                      }

                      /* Container for the scrollable content */
                      .scroll-container {
                        margin: 0 -6px 0 0 !important;
                        padding: 0 6px 0 0 !important;
                        max-height: 80vh !important;
                        overflow-y: auto !important;
                      }
                    `}</style>

                    <div className="scroll-container ultra-thin-scrollbar">
                      <div className="space-y-3 max-h-80">
                        <ul className="divide-y divide-gray-200 mt-3">
                          {filteredUsers.map((member, index) => (
                            <li
                              key={member._id || index}
                              className="py-4 flex items-center cursor-pointer gap-3 hover:bg-gray-100 px-3 rounded-none transition group"
                              onClick={() => toggleUser(index, member._id)}
                            >
                              <input
                                type="radio"
                                checked={selectedUsers.some((user) => user.userId === member._id)}
                                readOnly
                                className="form-checkbox h-5 w-5 text-shoorah-primary border-gray-300 rounded focus:shadow-shoorah-primary cursor-pointer"
                              />

                              <div className="flex-shrink-0 h-10 w-10">
                                <img
                                  className="h-10 w-10 rounded-full object-cover"
                                  src={member.image || dummyAvatar}
                                  alt={member.name}
                                />
                              </div>

                              <div className="ml-1">
                                <h3 className="text-xl font-medium dark:text-gray-200 text-[#1E2A3B] group-hover:text-black">
                                  {member.name
                                    ? member.name
                                        .split(' ')
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase()
                                        )
                                        .join(' ')
                                    : ''}
                                </h3>
                                <p className="text-base font-normal dark:text-gray-200 text-[#0C1218] group-hover:text-black">
                                  {member.job_role
                                    ? member.job_role
                                        .split(' ')
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1).toLowerCase()
                                        )
                                        .join(' ')
                                    : ''}
                                </p>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* Dialoge Box for Update users  */}
      <Transition.Root appear show={updateUsersPlanOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          initialFocus={cancelButtonRef}
          onClose={setaddUsersOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 dark:bg-black bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-white dark:bg-gray-800 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl">
                  <div className="bg-white dark:bg-gray-800 p-6 border border-gray-300 dark:border-shoorah-darkBorder rounded-lg">
                    <div className="flex justify-between items-center mb-4">
                      <p className="text-xl text-[#0B1D2E] dark:text-shoorah-bodyBackground font-semibold">
                        Purchase Details
                      </p>
                      <button
                        className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100"
                        onClick={() => setupdateUsersPlanOpen(false)}
                      >
                        <svg
                          width="46"
                          height="46"
                          viewBox="0 0 46 46"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="stroke-current"
                        >
                          <path
                            d="M17.25 28.75L28.75 17.25"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M28.75 28.75L17.25 17.25"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="flex flex-col w-full max-w-4xl mt-0 bg-white dark:bg-gray-800 my-5">
                      {typeOfPayment === 1 ? (
                        <>
                          <div className="w-full sm:w-full lg:w-full mr-auto mt-2 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                            <div className="flex-1 px-4 sm:px-6 py-3 sm:py-4 bg-gray-100 dark:bg-gray-800 border-b border-gray-300 dark:border-shoorah-darkBorder flex justify-between items-center">
                              <div className="text-gray-700 dark:text-gray-300 font-medium text-sm sm:text-base">
                                {typeOfPayment === 1 ? 'View Plans' : 'Current Plan'}
                              </div>
                              <div className="inline-flex px-1 sm:px-2 h-8 items-center justify-center border border-gray-300 rounded-md bg-white dark:bg-shoorah-darkGray text-black dark:text-white text-sm sm:h-6 sm:text-sm md:h-8 md:text-base">
                                {employeeCount === 99999 ? 'N/A' : employeeCount}
                              </div>
                            </div>

                            <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer">
                                <div className="flex-1">
                                  <span className="font-medium text-gray-900 dark:text-gray-300 text-sm sm:text-base">
                                    {plans['telephonic']?.title}
                                  </span>

                                  <div className="mt-2 mb-2">
                                    {plans['telephonic']?.planRequirements.map((text, index) => (
                                      <span
                                        key={index}
                                        className="text-[#606060] dark:text-gray-300 flex my-2 flex-row text-xs sm:text-sm"
                                      >
                                        <img
                                          src={instantSupportTick}
                                          alt="DropdownIcon"
                                          className="w-[24px] h-[24px] dark:invert"
                                        />
                                        {text}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                                <div className="flex flex-col mb-auto">
                                  <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                                    <span className=" text-base sm:text-2xl">£</span>
                                    {isAnnual
                                      ? plans['telephonic']?.priceAnnually
                                      : plans['telephonic']?.price.toFixed(2)}
                                    <span className="font-normal">
                                      {isAnnual ? '/yr' : '/month'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="w-full sm:w-full lg:w-full mr-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                            <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer">
                                <div className="flex-1">
                                  <span className="font-medium text-gray-900 dark:text-gray-300 text-sm sm:text-base">
                                    {plans['face']?.title}
                                  </span>

                                  <div className="mt-2 mb-2">
                                    {plans['face']?.planRequirements.map((text, index) => (
                                      <span
                                        key={index}
                                        className="text-[#606060] dark:text-gray-300 flex my-2 flex-row text-xs sm:text-sm"
                                      >
                                        <img
                                          src={instantSupportTick}
                                          alt="DropdownIcon"
                                          className="w-[24px] h-[24px] dark:invert"
                                        />
                                        {text}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                                <div className="flex flex-col mb-auto">
                                  <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                                    <span className=" text-base sm:text-2xl">£</span>
                                    {isAnnual
                                      ? plans['face']?.priceAnnually
                                      : plans['face']?.price.toFixed(2)}

                                    <span className="font-normal">
                                      {isAnnual ? '/yr' : '/month'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="w-full sm:w-full lg:w-full mr-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                            <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer">
                                <div className="flex-1">
                                  <span className="font-medium text-gray-900 dark:text-gray-300 text-sm sm:text-base">
                                    {plans['rise']?.title}
                                  </span>

                                  <div className="mt-2 mb-2">
                                    {plans['rise']?.planRequirements.map((text, index) => (
                                      <span
                                        key={index}
                                        className="text-[#606060] dark:text-gray-300 flex my-2 flex-row text-xs sm:text-sm"
                                      >
                                        <img
                                          src={instantSupportTick}
                                          alt="DropdownIcon"
                                          className="w-[24px] h-[24px] dark:invert"
                                        />
                                        {text}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                                <div className="flex flex-col mb-auto">
                                  <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                                    <span className=" text-base sm:text-2xl">£</span>
                                    {isAnnual
                                      ? plans['rise']?.priceAnnually
                                      : plans['rise']?.price.toFixed(2)}

                                    <span className="font-normal">
                                      {isAnnual ? '/yr' : '/month'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="w-full sm:w-full lg:w-full mr-auto mt-2 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                            <div className="flex-1 px-4 sm:px-6 py-3 sm:py-4 bg-gray-100 dark:bg-gray-800 border-b border-gray-300 dark:border-shoorah-darkBorder flex justify-between items-center">
                              <div className="text-gray-700 dark:text-gray-300 font-medium text-sm sm:text-base">
                                Current plan
                              </div>
                              <div className="w-12 h-8 flex items-center justify-center border border-gray-300 rounded-md bg-white dark:bg-shoorah-darkGray text-black dark:text-white text-sm sm:w-10 sm:h-6 sm:text-sm md:w-12 md:h-8 md:text-base">
                                {employeeCount}
                              </div>
                            </div>

                            <div className="space-y-0 divide-y divide-gray-200 dark:divide-shoorah-darkBorder">
                              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer">
                                <div className="flex-1">
                                  <span className="font-medium text-gray-900 dark:text-gray-300 text-sm sm:text-base">
                                    {plans[selectedPlan]?.title}
                                  </span>

                                  <div className="mt-2 mb-2">
                                    {plans[selectedPlan]?.planRequirements.map((text, index) => (
                                      <span
                                        key={index}
                                        className="text-[#606060] dark:text-gray-300 flex my-2 flex-row text-xs sm:text-sm"
                                      >
                                        <img
                                          src={instantSupportTick}
                                          alt="DropdownIcon"
                                          className="w-[24px] h-[24px] dark:invert"
                                        />
                                        {text}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                                <div className="flex flex-col mb-auto">
                                  <div className="text-gray-900 font-semibold dark:text-gray-400 text-sm sm:text-xl">
                                    <span className=" text-base sm:text-2xl">£</span>
                                    {isAnnual
                                      ? plans[selectedPlan]?.priceAnnually
                                      : plans[selectedPlan]?.price.toFixed(2)}
                                    <span className="font-normal">
                                      {isAnnual ? '/yr' : '/month'}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="w-full sm:w-full lg:w-full mr-auto mt-6 bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl overflow-hidden">
                        <div className="px-4 sm:px-6 py-4 bg-white dark:bg-shoorah-darkBgTabColor border-b border-gray-300 dark:border-shoorah-darkBorder flex justify-between items-center">
                          <div className="text-black dark:text-gray-300 font-medium text-base">
                            Add Users:
                          </div>
                        </div>
                        <div className="px-4 sm:px-6 py-4 bg-white dark:bg-shoorah-darkBgTabColor border-b border-gray-300 dark:border-shoorah-darkBorder flex justify-between items-center">
                          <div className="text-gray-700 dark:text-gray-300 font-medium text-xs">
                            How many employees do you wish to add to this plan?
                          </div>

                          <input
                            type="number"
                            className="w-16 h-9 p-2 border text-sm font-medium border-gray-300 dark:border-gray-600 rounded-lg text-black dark:text-gray-200 bg-white dark:bg-gray-800 text-center placeholder:text-gray-500"
                            value={numberOfUsersForUpgradeUsers}
                            onChange={(e) => {
                              setnumberOfUsersForUpgradeUsers(e.target.value);
                            }}
                            placeholder="10"
                          />
                        </div>

                        <div className="px-4 sm:px-6 py-4 bg-white dark:bg-shoorah-darkBgTabColor border-b border-gray-300 dark:border-shoorah-darkBorder flex justify-between items-center">
                          <div className="text-gray-700 dark:text-gray-300 font-medium text-xs">
                            Plan purchased date
                          </div>
                          <span className="text-sm text-gray-900 font-medium dark:text-gray-400">
                            {planPurchaseDate
                              ? new Date(planPurchaseDate).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: '2-digit',
                                  year: 'numeric'
                                })
                              : '-'}
                          </span>
                        </div>
                      </div>

                      <button
                        onClick={() => {
                          handleUpgradeUsers();
                        }}
                        className="btn-primary mt-8"
                      >
                        Increase employees range
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* Dialoge for deactivate feature */}
      <Transition.Root appear show={deactivateInstantSupportOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          initialFocus={cancelButtonRef}
          onClose={setaddUsersOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 dark:bg-black bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-white dark:bg-gray-800 text-left transition-all sm:my-8 sm:w-full sm:max-w-[512px]">
                  <div className="bg-white dark:bg-gray-800 p-6 border border-gray-300 dark:border-shoorah-darkBorder rounded-lg">
                    {/* <div className="flex justify-between items-center mb-4">
                      <p className="text-xl font-normal">Add On</p>
                      
                    </div> */}
                    <center>
                      <div className="font-normal text-base">
                        Are you sure you want to turn off the Instant Support (EAP) feature, you can
                        always turn it back on when needed.
                      </div>
                    </center>

                    <div className="flex items-center justify-center w-full">
                      <button
                        onClick={() => {
                          setdeactivateInstantSupportOpen(false);
                        }}
                        className="w-full mx-1 sm:w-[140px] p-2 mt-8 text-sm font-normal rounded-full text-black border border-black bg-white"
                      >
                        Cancel
                      </button>

                      <button
                        onClick={() => {
                          deactivateInstantSupport();
                          console.log('start');
                          handleRefreshOfTable();
                          console.log('start x2');
                        }}
                        className="w-full mx-1 sm:w-[140px] p-2 mt-8 text-sm font-normal rounded-full border shadow-sm bg-[#F93D40] dark:bg-[#F93D40] text-shoorah-darkBg"
                      >
                        Deactivate
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* Dialoge for Success when Users get Upgraded */}
      <Transition.Root show={upgradeUserPaymentDialogOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          initialFocus={cancelButtonRef}
          onClose={setupgradeUserPaymentDialogOpen}
        >
          {/* Disable interactions with the background when modal is open */}
          <div
            className="fixed inset-0 bg-gray-500 dark:bg-black !bg-opacity-75 transition-opacity"
            inert={upgradeUserPaymentDialogOpen ? 'true' : undefined}
          />

          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor text-left shadow-xl transition-all sm:my-8 sm:w-[calc(100%-2rem] md:max-w-5xl">
                <div className="bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder p-8 md:py-16 md:px-[120px] border-[1.5px] border-shoorah-borderGray flex flex-col items-center justify-center text-center">
                  <div className="mt-6 md:mt-0 sm:ml-4 mb-8 flex flex-col items-center">
                    <Dialog.Title
                      as="h3"
                      className="md:text-[32px] text-3xl font-medium leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg"
                    >
                      <img
                        src={instantSupportDialogIcon}
                        alt="DropdownIcon"
                        className="dark:invert mx-auto"
                      />
                    </Dialog.Title>
                  </div>
                  <div>
                    <p className="text-lg text-gray-700 dark:text-gray-300">
                      The number of users in your current Instant Support (EAP) plan has increased.
                      Sent for approval, will notify soon
                    </p>
                    <Link
                      className="w-[173px] h-[40px] bg-[#1F1F1F] text-white text-lg font-normal rounded-full border border-gray-300 cursor-pointer shadow-sm flex items-center justify-center mx-auto mt-6"
                      onClick={() => {
                        setupgradeUserPaymentDialogOpen(false);
                        setTimeout(() => {
                          navigate(getPathForInstantSupport('/instant-support'));
                        }, 100);
                      }}
                    >
                      Got It
                    </Link>
                  </div>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* dialoge Box for warning/ notice message for B2B to switch to custom plan  */}
      <Transition.Root show={noticeToSwitchToCustomSupportOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          initialFocus={cancelButtonRef}
          onClose={setnoticeToSwitchToCustomSupportOpen}
        >
          {/* Disable interactions with the background when modal is open */}
          <div
            className="fixed inset-0 bg-gray-500 dark:bg-black !bg-opacity-75 transition-opacity"
            inert={noticeToSwitchToCustomSupportOpen ? 'true' : undefined}
          />

          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor text-left shadow-xl transition-all sm:my-8 sm:w-[calc(100%-2rem] md:max-w-5xl">
                <div className="bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder p-8 md:py-16 md:px-[120px] border-[1.5px] border-shoorah-borderGray flex flex-col items-center justify-center text-center">
                  <div className="mt-6 md:mt-0 sm:ml-4 mb-8 flex flex-col items-center">
                    <Dialog.Title
                      as="h3"
                      className="md:text-[32px] text-3xl font-medium leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg"
                    >
                      <img
                        src={instantSupportDialogIcon}
                        alt="DropdownIcon"
                        className="dark:invert mx-auto"
                      />
                    </Dialog.Title>
                  </div>
                  <div>
                    <p className="text-lg text-gray-700 dark:text-gray-300">
                      Are you sure you want to switch to the Custom Plan? Your current Shoorah
                      Instant Support plan will be deactivated, and the Custom Plan will begin. We
                      appreciate your decision. Thank you!
                    </p>
                    <div className="flex justify-center items-center gap-x-4 mt-6">
                      <Link
                        className="flex-grow max-w-[173px] h-[40px] bg-[#1F1F1F] text-white text-lg font-normal rounded-full border border-gray-300 cursor-pointer flex items-center justify-center"
                        onClick={() => {
                          setnoticeToSwitchToCustomSupportOpen(false);
                          setTimeout(() => {
                            navigate(
                              getPathForInstantSupport('/instant-support/add-custom-number')
                            );
                          }, 100);
                        }}
                      >
                        Yes, am sure
                      </Link>
                      <Link
                        className="flex-grow max-w-[173px] h-[40px] bg-white text-[#1F1F1F] text-lg font-normal rounded-full border border-gray-300 cursor-pointer flex items-center justify-center"
                        onClick={() => {
                          setnoticeToSwitchToCustomSupportOpen(false);
                        }}
                      >
                        No
                      </Link>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};
export default InstantSupportIndexPage;
